export const actionPlanner = {
	selectors: {
		actionPlannerDetail: '.js-action-planner-detail',
		actionPlannerEditorSwitchModeButton: '.js-edit-mode-activator',
		actionPlannerEditorViewComponent: '.js-edit-view-component',
		actionPlannerEditorEditComponent: '.js-edit-edit-component',
	},
}
